import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App.tsx';

// Note: StrictMode is disabled to prevent Keycloak double-initialization
// Keycloak can only be initialized once, and StrictMode causes double-rendering in dev
createRoot(document.getElementById('root')!).render(<App />);
